



import React, { useState, useRef } from "react";
import Chart from "react-apexcharts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import _ from "lodash";

const MaritalStatusChart = () => {
 
  const rawMartialStatusFilter = useSelector(state => state.dashboard?.martialStatusCount) || {
    categories: {},
    series: [{ name: "Default", data: [] }]
  };

 
  const martialStatusFilter = _.cloneDeep(rawMartialStatusFilter);

  // ✅ Convert object to array (e.g., {0: "Married"} -> ["Married"])
  const categories = Object.values(martialStatusFilter.categories || {});

  const [showModal, setShowModal] = useState(false);
  const chartRef = useRef(null);
  const modalChartRef = useRef(null);

  const options = {
    chart: {
      type: "bar",
      height: "350px",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        endingShape: "rounded",
      },
    },
    grid: {
      show: false,
    },
    xaxis: {
      categories: categories,
      title: {
        text: "",
        style: {
          color: "",
          fontWeight: "bold",
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ["#3A6073", "#3A6073"],
        inverseColors: false,
        opacityFrom: 0.9,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ["#ffffff"],
      },
      formatter: function (val) {
        return val + "%";
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + "%";
        },
      },
    },
  };

  const series = martialStatusFilter.series?.length > 0 ? martialStatusFilter.series : [];

  const exportChartAsPDF = async (isModal = false) => {
    const chartElement = document.getElementById(
      isModal ? "modal-chart-container" : "chart-container"
    );

    if (!chartElement) return;

    await new Promise((resolve) => setTimeout(resolve, 500)); // wait for ApexChart render
    const canvas = await html2canvas(chartElement, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("landscape", "pt", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 40, pdfWidth, pdfHeight);
    pdf.save("marital-status-chart.pdf");
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-md flex flex-col h-full">
        <div className="border-b px-4 py-3 rounded-t-lg gradiant2 flex justify-between items-center">
          <h3 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-bold uppercase">
            Marital Status of Household Members
          </h3>
        </div>

        <div
          className="cursor-pointer p-4"
          onClick={() => setShowModal(true)}
          title="Click to view fullscreen"
        >
          <div id="chart-container">
            <Chart
              ref={chartRef}
              options={options}
              series={series}
              type="bar"
              height={350}
              width={610}
            />
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center">
          <button
            className="absolute top-4 left-6 text-3xl font-bold text-gray-600 hover:text-black"
            onClick={() => setShowModal(false)}
          >
            ×
          </button>

          <div className="absolute top-4 right-6">
            <div className="relative inline-block text-left">
              <div className="origin-top-right absolute right-0 mt-2 w-40 gradiant2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1">
                  <button
                    onClick={() => exportChartAsPDF(true)}
                    className="w-full px-4 py-2 text-sm  text-[#856800] font-bold"
                  >
                    Export PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-4 text-[#856800] mt-8">
            Marital Status of Household Members
          </h2>

          <div id="modal-chart-container" className="w-[90vw] h-[80vh]">
            <Chart
              ref={modalChartRef}
              options={options}
              series={series}
              type="bar"
              height="100%"
              width="100%"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default MaritalStatusChart;
